import { usePurchaseVendorSelector } from 'src/components/Selectors/PurchaseVendorSelector/usePurchaseVendorSelector';
import { resolveTagValueDisplay } from 'src/components/TagsFormBody/TagValueCell';
import { useContent } from 'src/contexts/ContentContext';
import { useSellerAccountContext } from 'src/contexts/SellerAccountContext';
import { useSiteTimezoneContext } from 'src/contexts/SiteTimezoneContext/SiteTimezoneContext';
import { HorizontalTextList } from 'src/core/POS/HorizontalTextList';
import { vars } from 'src/core/themes';
import { useUserGroups } from 'src/hooks/useUserGroups';
import { TagIcon } from 'src/svgs';
import { ContentId } from 'src/utils/constants/contentId';
import { Tag } from 'src/WebApiController';

import * as styles from './EventInfo.css';

export type EventTagsDisplayProps = {
  tags?: Tag[] | null;
};

export function EventTagsDisplay({ tags }: EventTagsDisplayProps) {
  const { allActiveUserInfos } = useSellerAccountContext();
  const { userGroups } = useUserGroups();
  const { timeZone } = useSiteTimezoneContext();

  const { availableVendors } = usePurchaseVendorSelector({});
  const unknownText = useContent(ContentId.Unknown);

  if (!tags?.length) {
    return null;
  }

  const tagsByTagName = tags
    .filter((t) => t.value)
    .reduce(
      (acc, t) => {
        acc[t.key] = [...(acc[t.key] || []), t];
        return acc;
      },
      {} as Record<string, Tag[]>
    );

  return (
    <HorizontalTextList
      className={styles.eventTags}
      preIcon={<TagIcon size={vars.iconSize.s} />}
      texts={Object.entries(tagsByTagName).map(
        ([tagName, tags]) =>
          `${tagName}: ${tags.map((t) => resolveTagValueDisplay(t, allActiveUserInfos, userGroups, availableVendors, unknownText, timeZone)).join(', ')}`
      )}
      maxTextsToShow={3}
      maxTextsToShowOnHover={tags.length}
    />
  );
}
